import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const settings = (accountId, { isPhoenix, isSuperAdmin } = {}) => {
  const config = {
    parentNav: 'settings',
    routes: [
      'agent_bots',
      'agent_list',
      'attributes_list',
      'automation_list',
      'auditlogs_list',
      'billing_settings_index',
      'canned_list',
      'general_settings_index',
      'general_settings',
      'labels_list',
      'macros_edit',
      'macros_new',
      'macros_wrapper',
      'subscription_settings_index',
      'settings_applications_integration',
      'settings_applications_webhook',
      'settings_applications',
      'settings_credentials',
      'settings_credentials_list',
      'settings_credentials_new',
      'settings_credentials_edit',
      'settings_credentials_authorizing',
      'settings_inbox_finish',
      'settings_inbox_list',
      'settings_inbox_new',
      'settings_inbox_show',
      'settings_inboxes_add_agents',
      'settings_inboxes_page_channel',
      'settings_integrations_dashboard_apps',
      'settings_integrations_integration',
      'settings_integrations_slack',
      'settings_integrations_webhook',
      'settings_integrations',
      'settings_teams_add_agents',
      'settings_teams_edit_finish',
      'settings_teams_edit_members',
      'settings_teams_edit',
      'settings_teams_finish',
      'settings_teams_list',
      'settings_teams_new',
      'settings_sms_index',
      'sla_list',
      'settings_guest_journey',
      'settings_message_hooks',
    ],
    menuItems: [
      {
        icon: 'briefcase',
        label: 'SIDEBAR.ACCOUNT_SETTINGS',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator'],
        },
        toState: frontendURL(`accounts/${accountId}/settings/general`),
        toStateName: 'general_settings_index',
      },
      // chatlyn
      {
        icon: 'receipt-money',
        label: 'CHATLYN_SIDEBAR.SUBSCRIPTION',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator', 'agent'],
        },
        toState: frontendURL(`accounts/${accountId}/settings/subscription`),
        toStateName: 'subscription_settings_index',
      },
      {
        icon: 'people',
        label: 'SIDEBAR.AGENTS',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator'],
        },
        toState: frontendURL(`accounts/${accountId}/settings/agents/list`),
        toStateName: 'agent_list',
        featureFlag: FEATURE_FLAGS.AGENT_MANAGEMENT,
      },
      {
        icon: 'people-team',
        label: 'SIDEBAR.TEAMS',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator'],
        },
        toState: frontendURL(`accounts/${accountId}/settings/teams/list`),
        toStateName: 'settings_teams_list',
        featureFlag: FEATURE_FLAGS.TEAM_MANAGEMENT,
      },
      {
        icon: 'mail-inbox-all',
        label: 'SIDEBAR.INBOXES',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator'],
        },
        toState: frontendURL(`accounts/${accountId}/settings/inboxes/list`),
        toStateName: 'settings_inbox_list',
        featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
      },
      {
        icon: 'tag',
        label: 'SIDEBAR.LABELS',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator'],
        },
        toState: frontendURL(`accounts/${accountId}/settings/labels/list`),
        toStateName: 'labels_list',
        featureFlag: FEATURE_FLAGS.LABELS,
      },
      {
        icon: 'code',
        label: 'SIDEBAR.CUSTOM_ATTRIBUTES',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator'],
        },
        toState: frontendURL(
          `accounts/${accountId}/settings/custom-attributes/list`
        ),
        toStateName: 'attributes_list',
        featureFlag: FEATURE_FLAGS.CUSTOM_ATTRIBUTES,
      },
      {
        icon: 'automation',
        label: 'SIDEBAR.AUTOMATION',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator'],
        },
        toState: frontendURL(`accounts/${accountId}/settings/automation/list`),
        toStateName: 'automation_list',
        featureFlag: FEATURE_FLAGS.AUTOMATIONS,
      },
      {
        icon: 'bot',
        label: 'SIDEBAR.AGENT_BOTS',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator'],
        },
        globalConfigFlag: 'csmlEditorHost',
        toState: frontendURL(`accounts/${accountId}/settings/agent-bots`),
        toStateName: 'agent_bots',
        featureFlag: FEATURE_FLAGS.AGENT_BOTS,
      },
      {
        icon: 'flash-settings',
        label: 'SIDEBAR.MACROS',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator', 'agent'],
        },
        toState: frontendURL(`accounts/${accountId}/settings/macros`),
        toStateName: 'macros_wrapper',
        featureFlag: FEATURE_FLAGS.MACROS,
        hidden: isPhoenix,
        childRoutes: ['macros_new', 'macros_edit'],
      },
      {
        icon: 'chat-multiple',
        label: 'SIDEBAR.CANNED_RESPONSES',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator', 'agent'],
        },
        toState: frontendURL(
          `accounts/${accountId}/settings/canned-response/list`
        ),
        toStateName: 'canned_list',
        featureFlag: FEATURE_FLAGS.CANNED_RESPONSES,
        hidden: isPhoenix,
      },
      // AI Config - Phoenix only
      {
        icon: 'wand',
        label: 'SIDEBAR.AI_CONFIG',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator'],
        },
        toState: frontendURL(`accounts/${accountId}/settings/ai-config`),
        toStateName: 'settings_ai_config',
        hidden: !isPhoenix,
      },
      {
        icon: 'flash-on',
        label: 'SIDEBAR.INTEGRATIONS',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator'],
        },
        toState: frontendURL(`accounts/${accountId}/settings/integrations`),
        toStateName: 'settings_integrations',
        featureFlag: FEATURE_FLAGS.INTEGRATIONS,
        hidden: isPhoenix && !isSuperAdmin,
        childRoutes: [
          'settings_integrations_dashboard_apps',
          'settings_integrations_integration',
          'settings_integrations_slack',
          'settings_integrations_webhook',
        ],
      },
      {
        icon: 'star-emphasis',
        label: 'SIDEBAR.APPLICATIONS',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator'],
        },
        toState: frontendURL(`accounts/${accountId}/settings/applications`),
        toStateName: 'settings_applications',
        featureFlag: FEATURE_FLAGS.INTEGRATIONS,
      },
      // chatlyn
      {
        icon: 'key',
        label: 'CHATLYN_SIDEBAR.CREDENTIALS',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator'],
        },
        toState: frontendURL(`accounts/${accountId}/settings/credentials`),
        toStateName: 'settings_credentials_list',
        hidden: isPhoenix,
        childRoutes: [
          'settings_credentials',
          'settings_credentials_new',
          'settings_credentials_edit',
          'settings_credentials_authorizing',
        ],
      },
      // chatlyn
      {
        icon: 'chatlyn-sms',
        label: 'SIDEBAR.SMS_SENDING',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator'],
        },
        toState: frontendURL(`accounts/${accountId}/settings/sms`),
        toStateName: 'settings_sms_index',
        hidden: isPhoenix,
      },
      // Guest Journey - Phoenix only
      {
        icon: 'guest-journey',
        label: 'SIDEBAR.GUEST_JOURNEY',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator'],
        },
        toState: frontendURL(`accounts/${accountId}/settings/guest-journey`),
        toStateName: 'settings_guest_journey',
        hidden: !isPhoenix,
      },
      // Message Hooks - Phoenix only
      {
        icon: 'message-hooks',
        label: 'SIDEBAR.MESSAGE_HOOKS',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator'],
        },
        toState: frontendURL(`accounts/${accountId}/settings/message-hooks`),
        toStateName: 'settings_message_hooks',
        hidden: !isPhoenix,
      },
    ],
  };

  // Filter out hidden menu items and their routes (including child routes)
  const hiddenRoutes = config.menuItems
    .filter(item => item.hidden)
    .flatMap(item => [item.toStateName, ...(item.childRoutes || [])]);

  config.menuItems = config.menuItems.filter(item => !item.hidden);
  config.routes = config.routes.filter(route => !hiddenRoutes.includes(route));

  return config;
};

export default settings;
